export enum ErrorStatuses {
	CLOSED = 'CLOSED',
	PASSED = 'PASSED',
	NOT_FOUND = 'NOT_FOUND',
}
